/**
 * Landing page — built on the design language of Julian's "Home Screen"
 * template (v0-evasion). Full section spine ported 2026-06-12:
 * scroll hero → companion panels → app showcase grid (product design pages)
 * → features → UX journey gallery → share showcase → scripture editorial
 * → CTA. Light, quiet, scripture-first; dark moments are the Word and the
 * experience gallery.
 */
import { MinimalHeader } from "./components/landing/MinimalHeader";
import { ScrollHero } from "./components/landing/ScrollHero";
import { CompanionSection } from "./components/landing/CompanionSection";
import { AppShowcaseSection } from "./components/landing/AppShowcaseSection";
import { FeaturesSection } from "./components/landing/FeaturesSection";
import { UXGallerySection } from "./components/landing/UXGallerySection";
import { ShareSection } from "./components/landing/ShareSection";
import { ScriptureEditorial } from "./components/landing/ScriptureEditorial";
import { ClosingCta } from "./components/landing/ClosingCta";
import { MinimalFooter } from "./components/landing/MinimalFooter";
import "./App.css";

function Home() {
  return (
    <div className="bg-[#FAFAF7] text-neutral-900">
      <MinimalHeader />
      <main>
        <ScrollHero />
        <CompanionSection />
        <AppShowcaseSection />
        <FeaturesSection />
        <UXGallerySection />
        <ShareSection />
        <ScriptureEditorial />
        <ClosingCta />
      </main>
      <MinimalFooter />
    </div>
  );
}

export default Home;
